import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ArticleService } from 'src/app/core/services/article.service';
import { ToastService } from 'src/app/shared/components/toast/toast.service';

@Component({
  selector: 'app-modal-download-guide',
  templateUrl: './modal-download-guide.component.html',
  styleUrls: ['./modal-download-guide.component.scss'],
})
export class ModalDownloadGuideComponent implements OnInit {
  @ViewChild('contentGuide') contentGuide: any;

  @Input() guideType: 'vendeur' | 'acquereur' | 'bailleur' = 'vendeur';
  @Input() guideTitle: string = 'Guide Immobilier';
  @Input() guidePdfUrl: string = 'assets/pdf/Guide-vendeur-V202306.pdf';
  @Input() externalOpen?: Subject<{ type: string; title: string; pdfUrl: string }>;

  guideForm!: FormGroup;
  modalRef?: NgbModalRef;
  submitted = false;
  loading = false;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private articleService: ArticleService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.initForm();

    if (this.externalOpen) {
      this.externalOpen.subscribe((data) => {
        if (data) {
          if (data.type) this.guideType = data.type as any;
          if (data.title) this.guideTitle = data.title;
          if (data.pdfUrl) this.guidePdfUrl = data.pdfUrl;
        }
        this.open();
      });
    }
  }

  initForm(): void {
    this.guideForm = this.fb.group({
      prenom: ['', [Validators.required, Validators.minLength(2)]],
      nom: ['', [Validators.required, Validators.minLength(2)]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
        ],
      ],
      codePostal: [
        '',
        [Validators.required, Validators.pattern(/^[0-9]{5}$/)],
      ],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(?:(?:\+|00)33|0)[1-9](?:[\s.-]?\d{2}){4}$/),
        ],
      ],
    });
  }

  get f() {
    return this.guideForm.controls;
  }

  open(): void {
    (document.activeElement as HTMLElement)?.blur();
    this.submitted = false;
    this.loading = false;
    this.initForm();
    this.modalRef = this.modalService.open(this.contentGuide, {
      centered: true,
      size: 'lg',
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.guideForm.invalid) {
      return;
    }

    this.loading = true;
    const payload = {
      prenom: this.f['prenom'].value,
      nom: this.f['nom'].value,
      email: this.f['email'].value,
      codePostal: this.f['codePostal'].value,
      phone: this.f['phone'].value,
      guideTitle: this.guideTitle,
      guideType: this.guideType,
    };

    // 1. Lancement automatique du téléchargement du fichier PDF dans le navigateur
    const link = document.createElement('a');
    link.href = this.guidePdfUrl;
    link.download = this.guidePdfUrl.split('/').pop() || 'guide.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // 2. Envoi des informations au serveur backend Symfony
    this.articleService.downloadGuide(payload).subscribe({
      next: () => {
        this.loading = false;
        this.toastService.show(
          'Merci ! Votre guide a été téléchargé avec succès.',
          { classname: 'bg-success text-white', delay: 6000 }
        );
        this.modalRef?.close();
      },
      error: () => {
        this.loading = false;
        this.toastService.show(
          'Votre guide est en cours de téléchargement !',
          { classname: 'bg-success text-white', delay: 6000 }
        );
        this.modalRef?.close();
      },
    });
  }
}
